import React from "react"
import { graphql } from "gatsby"
import type { PageProps } from "gatsby"

import BuilderGenericPage, { BuilderModel } from "./builder-generic-page"

export default function BuilderPage({
    data,
}: Readonly<PageProps<Queries.oneBuilderPageQuery>>) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO fix eslint
    const ganericPage = data?.allBuilderModels.genericPage
    const pageData = ganericPage?.data
    const pageContent = ganericPage?.content

    return (
        <BuilderGenericPage
            {...pageData}
            content={pageContent}
            model={BuilderModel.Page}
        />
    )
}

// eslint-disable-next-line import/no-unused-modules -- imported by gatsby
export const pageQuery = graphql`
    query oneBuilderPage($path: String!) {
        allBuilderModels {
            genericPage: onePage(
                target: { urlPath: $path }
                options: { cachebust: true }
            ) {
                content
                data {
                    title
                    description
                    metaImage
                    shouldHideFooter
                    shouldHideHeader
                    shouldHideChat
                    noIndex
                }
            }
        }
    }
`
